import { memo, useContext, useState } from 'react'
import { Button, Theme, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { makeStyles, createStyles } from '@mui/styles'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { IBankCTAButtonProps } from '../typings'
import { BankListContext } from '../BankListContext'
import { trackBanklistCTAClick } from '../../../utils/segment'

const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    buttonContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: 10,
    },
    ctaButtonCls: {
      pointerEvents: 'auto',
      cursor: 'pointer',
      marginTop: 15,
      color: theme.palette.primary.contrastText,
    },
    productDetailsLink: {
      fontSize: 14,
      color: theme.palette.grey[500],
    },
    productDetailsExpander: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: 5,
      cursor: 'pointer',
      pointerEvents: 'auto',
    },
    expandIcon: {
      color: theme.palette.grey[500],
    },
  }),
)

const BankListCTA = ({
  productId,
  isRowExpanded,
  expandHandler,
}: IBankCTAButtonProps) => {
  const {
    productDetailsExpander,
    buttonContainer,
    productDetailsLink,
    ctaButtonCls,
    expandIcon,
  } = useStyles()
  const [isDisabled, setIsDisabled] = useState({ [productId]: false })
  const { loanSelectorState, handleCTAButtonClick } =
    useContext(BankListContext)

  const handleWeiterCTAClick = (buttonId: string) => {
    trackBanklistCTAClick({
      ...loanSelectorState,
      productId,
      pageUrl: window?.location?.href,
    })

    setIsDisabled({
      [buttonId]: true,
    })
    handleCTAButtonClick?.(setIsDisabled, productId, loanSelectorState)
  }

  return (
    <div className={buttonContainer}>
      <Button
        id={productId}
        variant='contained'
        fullWidth
        size='large'
        disabled={isDisabled[productId]}
        className={ctaButtonCls}
        endIcon={<ChevronRightIcon />}
        onClick={(event) => {
          event?.stopPropagation()
          handleWeiterCTAClick(productId)
        }}
      >
        Weiter
      </Button>
      <div
        role='button'
        className={productDetailsExpander}
        onClick={() => expandHandler(productId)}
      >
        <Typography className={productDetailsLink}>Produktdetails</Typography>
        {!isRowExpanded ? (
          <ExpandMoreIcon className={expandIcon} />
        ) : (
          <ExpandLessIcon className={expandIcon} />
        )}
      </div>
    </div>
  )
}

export default memo(BankListCTA)
